import { PLANNE_CONCIERGE_PHONE_NUMBER } from '../constants';

export type CashbackWhatsappMessageParams = {
  buyerFirstName?: string;
  sellerName: string;
  orderCode: string;
  amountCents: number;
};

/**
 * Message the buyer sends to Planne Concierge. It is read by the Concierge
 * team, so it stays in Portuguese whatever the widget locale.
 */
export const buildCashbackWhatsappMessage = (params: CashbackWhatsappMessageParams): string => {
  const { buyerFirstName, sellerName, orderCode, amountCents } = params;
  const name = buyerFirstName?.trim() ?? '';
  const amount = (amountCents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return `Quero resgatar meu cashback. Eu sou ${name}, fiz uma compra de R$${amount} em ${sellerName} e meu pedido é o ${orderCode}. Gostaria de usar o cashback em outras atrações.`;
};

export const buildCashbackWhatsappUrl = (params: CashbackWhatsappMessageParams): string =>
  `https://wa.me/${PLANNE_CONCIERGE_PHONE_NUMBER}?text=${encodeURIComponent(buildCashbackWhatsappMessage(params))}`;
